import { formatUsd } from '@/Client/Presenters';
import { compact } from '@art-suite/art-core-ts';
import { ScanLifecycleStatus, ScanType } from '@kaiizen/kai-pro-api';
import { ReactNode } from 'react';
import { ScanStatusPill } from '../Partials/ScanStatusPill';
import { PageSubHeaderBar } from './PageSubHeaderBar';

export const ScanEditorPageTitleBar = (
  { title, area, cost, scanType, showArea = false, showCost = true, scanLifecycleStatus, archivedAt, buttons, flushButtons = false }: {
    title: string;
    area?: number;
    cost?: number;
    showArea?: boolean;
    showCost?: boolean;
    scanType?: ScanType;
    scanLifecycleStatus?: ScanLifecycleStatus;
    archivedAt?: Date;
    buttons?: ReactNode[];
    flushButtons?: boolean;
  },
) => (
  <PageSubHeaderBar
    title={title}
    titleIcons={scanLifecycleStatus
      ? [<ScanStatusPill key='scanStatusPill' scanType={scanType} status={scanLifecycleStatus} tight archivedAt={archivedAt} />]
      : undefined}
    buttons={buttons}
    labeledValues={compact([
      showArea ? { label: 'Area', value: Math.round(area ?? 0).toString(), unit: 'sqft' } : undefined,
      showCost ? { label: 'Cost', value: formatUsd(cost ?? 0) } : undefined,
    ])}
    flushButtons={flushButtons}
  />
);
